/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_StackInputs */

const en_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack`)
};

const ar_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقنيات`)
};

const bn_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্যাক`)
};

const de_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapel`)
};

const es_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pila`)
};

const fr_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pile`)
};

const pt_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilha`)
};

const zh_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`堆栈`)
};

const tr_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yığın`)
};

const ru_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стек`)
};

const pl_resume_tag_stack = /** @type {(inputs: Resume_Tag_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stos`)
};

/**
* | output |
* | --- |
* | "Stack" |
*
* @param {Resume_Tag_StackInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_stack = /** @type {((inputs?: Resume_Tag_StackInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_StackInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_stack(inputs)
	if (locale === "bn") return bn_resume_tag_stack(inputs)
	if (locale === "de") return de_resume_tag_stack(inputs)
	if (locale === "es") return es_resume_tag_stack(inputs)
	if (locale === "fr") return fr_resume_tag_stack(inputs)
	if (locale === "pt") return pt_resume_tag_stack(inputs)
	if (locale === "zh") return zh_resume_tag_stack(inputs)
	if (locale === "tr") return tr_resume_tag_stack(inputs)
	if (locale === "ru") return ru_resume_tag_stack(inputs)
	if (locale === "pl") return pl_resume_tag_stack(inputs)
	return en_resume_tag_stack(inputs)
});